export const ArrowDown = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
        fill="#D9D9D9"
      />
      <path
        d="M12.3434 16.9991C12.1521 17.1904 11.842 17.1904 11.6507 16.9991L8.53369 13.8821C8.34241 13.6908 8.34241 13.3807 8.53369 13.1894C8.72497 12.9981 9.03509 12.9981 9.22637 13.1894L11.9971 15.9601L14.7678 13.1894C14.9591 12.9981 15.2692 12.9981 15.4605 13.1894C15.6517 13.3807 15.6517 13.6908 15.4605 13.8821L12.3434 16.9991ZM12.4869 7.34668V16.6528H11.5073V7.34668H12.4869Z"
        fill="black"
      />
    </svg>
  );
};
